export default __webpack_public_path__ + "static/media/language_selected.7e7b5b78.svg";